import * as lang from './lang.json';
import ssnLogo from '../../assets/images/ssn-logo.svg';
import './Footer.css';

/**
 * Main component.
 * @name Footer
 * @returns {<Footer />}
 */
const Footer = () => {
  return (
    <footer className="saa-footer container-full px-3 px-lg-4 px-xl-5">
      <div className="row">
        <div className="saa-footer-col saa-footer-col--left col-md-8">
          <p className="saa-footer-text">{lang.intro}</p>
          <p className="saa-footer-text">
            {lang.formIntro}
            <a href={lang.formLinkHref} target="_blank" rel="noopener noreferrer">{lang.formLinkText}</a>
            {lang.formOutro}
          </p>
          <div className="saa-footer-text">
            <p><strong>{lang.responsableLabel}</strong><br />{lang.responsableName}</p>
            <p>{lang.phoneLabel} <a href={lang.responsablePhoneHref}>{lang.responsablePhone}</a>.</p>
          </div>
          <div className="saa-footer-text">
            <p><strong>{lang.suplenteLabel}</strong><br />{lang.suplenteName}</p>
            <p>{lang.phoneLabel} <a href={lang.suplentePhoneHref}>{lang.suplentePhone}</a>.</p>
          </div>
        </div>
        <div className="saa-footer-col saa-footer-col--right col-md-4">
          <h4 className="saa-footer-heading">{lang.ssnHeading}</h4>
          <img className="saa-footer-logo" src={ssnLogo} alt={lang.ssnLogoAlt} />
          <p className="saa-footer-text">
            {lang.complaintIntro}
            <a href={lang.complaintLinkHref} target="_blank" rel="noopener noreferrer">{lang.complaintLinkText}</a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
